import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-mist py-6 sm:py-9" data-id="element-63" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-[1080px] flex-col items-center gap-3 px-4 text-center sm:flex-row sm:gap-5 sm:px-6 sm:text-left" data-id="element-64" data-mp="1o33xor06cami">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-gold sm:h-24 sm:w-24" data-id="element-65" data-mp="1x4bpqrc3kf85">
          <ShieldCheckIcon className="h-7 w-7 sm:h-8 sm:w-8" strokeWidth={2} aria-hidden="true" data-id="element-66" data-mp="19facmqsbkfwj" />
          <span className="mt-0.5 font-display text-[11px] font-bold uppercase leading-none tracking-wide" data-id="element-67" data-mp="14h8ymk9r36rx">
            7 days
          </span>
        </div>
        <div data-id="element-68" data-mp="1edbyfjh4qtbp">
          <h2 className="text-[21px] leading-none text-navy sm:text-[30px]" data-id="element-69" data-mp="1edkdni0q6aq2">
            Your purchase is <span className="text-diag" data-id="element-70" data-mp="qnhkeyl2qypv">100% protected</span>
          </h2>
          <p className="mt-2 text-[13.5px] font-medium leading-snug text-steel sm:text-[16px]" data-id="element-71" data-mp="lpg2wi3ar7gi">
            Explore GASOLINE ENGINE DIAGNOSTIC PRO™ for 7 days. Access the complete
            6-module diagnostic system and all 5 strategic bonuses. If it isn't right
            for you, contact us within 7 days for a full refund according to the
            refund terms.
          </p>
        </div>
      </div>
    </section>;
}